import text from './menu-icons/text.png';
import list from './menu-icons/list.png';
import image from './menu-icons/image.png';
import video from './menu-icons/video.png';
import icon from './menu-icons/icon.png';
import divider from './menu-icons/divider.png';
import button from './menu-icons/button.png';

export const menuIcons = {
    text: text,
    list: list,
    image: image,
    video: video,
    icon: icon,
    divider: divider,
    button: button
};